var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.429199,
    y: 0.734375,
    width: 27.1201,
    height: 27.1201,
    rx: 13.5601,
    fill: "#E2FFF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3471 15.579C14.6008 15.579 15.6171 14.5627 15.6171 13.309C15.6171 12.0554 14.6008 11.0391 13.3471 11.0391C12.0934 11.0391 11.0771 12.0554 11.0771 13.309C11.0771 14.5627 12.0934 15.579 13.3471 15.579Z",
    fill: "#00CE8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 20.4107C9.10791 18.0716 11.0036 16.1719 13.3468 16.1719C15.69 16.1719 17.5857 18.0676 17.5857 20.4107",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 20.4107C9.10791 18.0716 11.0036 16.1719 13.3468 16.1719C15.69 16.1719 17.5857 18.0676 17.5857 20.4107",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 20.4107C9.10791 18.0716 11.0036 16.1719 13.3468 16.1719C15.69 16.1719 17.5857 18.0676 17.5857 20.4107",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 20.4107C9.10791 18.0716 11.0036 16.1719 13.3468 16.1719C15.69 16.1719 17.5857 18.0676 17.5857 20.4107",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 20.4107C9.10791 18.0716 11.0036 16.1719 13.3468 16.1719C15.69 16.1719 17.5857 18.0676 17.5857 20.4107",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10791 20.4107C9.10791 18.0716 11.0036 16.1719 13.3468 16.1719C15.69 16.1719 17.5857 18.0676 17.5857 20.4107",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenef);
export default __webpack_public_path__ + "static/media/benef.023079cb10e6e2f4d210756cb3b5fb7e.svg";
export { ForwardRef as ReactComponent };